import { useState, useEffect, useCallback } from 'react';
import { setToken } from '../lib/api';

// Session-token auth. Token comes from /auth/login (password) or passkey login,
// is stored in localStorage and sent as a Bearer header by the api helper.
export const useAuth = () => {
  const [token, setTok] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('dashboard_token');
    if (stored) { setToken(stored); setTok(stored); }
  }, []);

  const login = useCallback((t) => {
    setToken(t);
    setTok(t);
    localStorage.setItem('dashboard_token', t);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTok(null);
    localStorage.removeItem('dashboard_token');
  }, []);

  return { token, login, logout, isLoggedIn: token !== null };
};
